import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

// ✅ Consistent endpoint for the Plan API
const BASE_URL = `${API_BASE_PATH}/plans`;

// ✅ Plan Interface
export interface Plan {
  plan_id?: string;
  plan_name: string;
  plan_type: string;
  plan_position: string;
  no_admin: string;
  no_user: string;
  plan_price: number;
  plan_currency: string;
  discount_type: string;
  discount_percentage: string;
  trail_days: number;
  status: string;
  Upload_file?: File;
  created_at?: string;
}

// ✅ Fetch all plans
export const fetchPlans = async (): Promise<Plan[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/`);
    return response.data;
  } catch (error) {
    toast.error("Failed to fetch plans");
    throw error;
  }
};

// ✅ Create a new plan
export const createPlan = async (planData: Plan): Promise<Plan | null> => {
  try {
    const formData = new FormData();
    Object.entries(planData).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, value as any);
      }
    });

    const response = await axios.post(`${BASE_URL}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    toast.error("Failed to create plan");
    throw error;
  }
};

// ✅ Update an existing plan
export const updatePlan = async (
  planId: string,
  planData: Plan
): Promise<Plan | null> => {
  try {
    const formData = new FormData();
    Object.entries(planData).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, value as any);
      }
    });

    const response = await axios.put(`${BASE_URL}/${planId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    toast.error("Failed to update plan");
    throw error;
  }
};

// ✅ Delete a plan
export const deletePlan = async (planId: string): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/${planId}`);
    toast.success("Plan deleted successfully");
  } catch (error) {
    toast.error("Failed to delete plan");
    throw error;
  }
};
